export default "__VITE_ASSET__DwFtIdOD__"